import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';
import { keyGen } from '../lib/util';
import { TipoMensagem, OrigemMensagem } from '../models/mensagem';
import { ServidorProvider } from '../providers/servidor/servidor'

var brComDaoInstance: BrComDao;

enum condicionalString {
    TRUE = "V",
    FALSE = "F"
}

enum chaveLocalStorage {
    MENSAGENS = "mensagens_",
    LISTA_MENSAGENS_NAO_LIDAS = "lista_mensagens_nao_lidas_",
    DENUNCIAS = "denuncias_",
    PUSH_CODE = "pushCode",
    GRUPOS = "grupos",
    HEX_APARELHO = "hexAparelho",
    TELEFONE = "telefone",
    CPF = "cpf",
    DEVICE_ID = "deviceId",
    STATUS_MENSAGENS_NAO_LIDAS_EMPRESA = "status_mensagens_nao_lidas_empresa_",
    REDES_SOCIAIS = "redes_sociais_",
    LAYOUT = "layout_",
    CONTATOS = "contatos",
    AREAS = "areas"
}

@Injectable()
export class BrComDao {

    private grupos = null;
    private pushCode = null;
    private telefone = null;
    private cpf = null;
    private deviceId = null;

    constructor(private events: Events) {
        brComDaoInstance = this; 
    }

    limpaDados() {
        this.grupos = null;
        localStorage.clear();
    }

    obtemTelefone(): string {
        this.loadInfoFromStorage();
        return this.telefone;
    }

    gravaPushCode(pushCode: string) {
        this.pushCode = pushCode;
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.PUSH_CODE, JSON.stringify(pushCode));
    }

    lePushCode(): string {
        return this.pushCode;
    }

    obtemGrupos(): any[] {
        this.loadInfoFromStorage();
        return this.grupos;
    }

    public getEmpresa(): any {
        return this.grupos[0];
    }

    obtemGrupo(codEmpresa: number): any {
        for (let grupo of this.grupos)
            if (grupo.CodEmpresa == codEmpresa)
                return grupo;
        return null;
    }

    gravaGrupo(grupos: any[]) {
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.GRUPOS, JSON.stringify(grupos));
        this.grupos = grupos;
    }

    gravaHexAparelho(hexAparelho: string) {
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.HEX_APARELHO, hexAparelho);
    }

    gravaTelefone(telefone: string) {
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.TELEFONE, JSON.stringify(telefone));
    }

    gravaCpf(cpf: string) {
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.CPF, JSON.stringify(cpf));
    }

    gravarLayoutPreferencial(layout: number, codEmpresa: number): void {
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.LAYOUT, layout, codEmpresa);
    }

    recuperarLayoutPreferencial(codEmpresa): number {
        const valor = brComDaoInstance.getValorChaveLocalStorage(chaveLocalStorage.LAYOUT, codEmpresa);
        return Number(valor);
    }

    gravaMensagens(usuarios: any[]) {
        for (let u of usuarios) {
            if (u.Mensagens){
                let mensagens = brComDaoInstance.obtemMensagensEmpresa(u.CodEmpresa);
                for (let m of u.Mensagens){
                    mensagens.push(m)
                }
                brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.MENSAGENS, JSON.stringify(mensagens), u.CodEmpresa);
            }       
        }
    }

    gravarAreasUsuarios(usuarios: any[]) {
        for (const usuario of usuarios) {
            this.gravarAreas(usuario.Areas);
        };
    }

    gravarAreas(areas: any) {
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.AREAS, JSON.stringify(areas));
    }

    getAreas() {
        const areas = brComDaoInstance.getValorChaveLocalStorage(chaveLocalStorage.AREAS);
        if (areas) {
            return JSON.parse(areas);
        }
        return [];
    }

    loadInfoFromStorage(): boolean {
        if (this.grupos != null)
            return true;
        var ls = brComDaoInstance.getValorChaveLocalStorage(chaveLocalStorage.GRUPOS);
        if (ls) {
            this.grupos = JSON.parse(ls);
            ls = brComDaoInstance.getValorChaveLocalStorage(chaveLocalStorage.PUSH_CODE);
            if (ls)
                this.pushCode = JSON.parse(ls);
            else
                this.pushCode = null;
            ls = brComDaoInstance.getValorChaveLocalStorage(chaveLocalStorage.TELEFONE);
            if (ls)
                this.telefone = JSON.parse(ls);
            else
                this.telefone = null;
            ls = brComDaoInstance.getValorChaveLocalStorage(chaveLocalStorage.CPF);
            if (ls)
                this.cpf = JSON.parse(ls);
            else
                this.cpf = null;
            ls = brComDaoInstance.getValorChaveLocalStorage(chaveLocalStorage.DEVICE_ID);
            if (ls)
                this.deviceId = JSON.parse(ls);
            else
                this.deviceId = null;
            return true;
        } else
            return false;
    }

    adicionaDataHora(msg: any) {
        let getFormattedDate = function () {
            var date = new Date();
            var year = date.getFullYear();

            var month = (1 + date.getMonth()).toString();
            month = month.length > 1 ? month : '0' + month;

            var day = date.getDate().toString();
            day = day.length > 1 ? day : '0' + day;

            return day + '/' + month + '/' + year;
        }
        let getFormattedHour = function () {
            var date = new Date();
            return date.toTimeString().split(' ')[0].substring(0, 5);
        }
        msg['data'] = getFormattedDate();
        msg['hora'] = getFormattedHour();
    }

    adicionaMensagemSimples(msg: any) {
        let codEmpresa = msg.codEmpresa;
        let mensagens = brComDaoInstance.obtemMensagensEmpresa(codEmpresa);
        var m = {
            tipo: TipoMensagem.SIMPLES,
            codEmpresa: msg.codEmpresa,
            codUsuario: msg.codUsuario,
            idMensagemUsuario: msg.idMensagemUsuario? msg.idMensagemUsuario : undefined,
            statusMensagemRecebida: false,
            statusMensagemLida: false,
            textoTipoMensagem: msg.textoTipoMensagem,
            mensagem: msg.mensagem,
            origem: OrigemMensagem.DIREITA
        };
        brComDaoInstance.adicionaDataHora(m);
        mensagens.push(m);
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.MENSAGENS, JSON.stringify(mensagens), codEmpresa);
        brComDaoInstance.events.publish("msg.empresa." + msg.codEmpresa, {});
        brComDaoInstance.events.publish("pagina.empresa.atualizada", msg.codEmpresa);        
        brComDaoInstance.marcaMensagemNaoLidaEmEmpresa(msg.codEmpresa);
    }

    marcaStatusMsgsNaoLidaEmpresa(codEmpresa: number, naoLida: boolean) {
        if (naoLida) {
            brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.STATUS_MENSAGENS_NAO_LIDAS_EMPRESA, condicionalString.TRUE, codEmpresa);
        }else {
            brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.STATUS_MENSAGENS_NAO_LIDAS_EMPRESA, condicionalString.FALSE, codEmpresa);
        }
        brComDaoInstance.events.publish("pagina.empresa.atualizada", {});
    }

    getStatusMsgsNaoLidaEmpresa(codEmpresa: number): boolean {
        let statusNaoLida = brComDaoInstance.getValorChaveLocalStorage(chaveLocalStorage.STATUS_MENSAGENS_NAO_LIDAS_EMPRESA, codEmpresa);
        if (statusNaoLida == condicionalString.TRUE) {
            return true
        }
        return false
    }

    marcaMensagemNaoLidaEmEmpresa(codEmpresa: number) {
        brComDaoInstance.events.publish("marcaNaoLidaSeNaoEstiverEmRotinaLeitura", {codEmpresa:codEmpresa});
    }

    adicionaMensagemResposta(msg: any) {
        let codEmpresa = msg.codEmpresa;
        let mensagens = brComDaoInstance.obtemMensagensEmpresa(codEmpresa);
        var m = {
            tipo: TipoMensagem.RESPOSTA,
            codEmpresa: msg.codEmpresa,
            codUsuario: msg.codUsuario,
            idMensagemUsuario: msg.idMensagemUsuario? msg.idMensagemUsuario : undefined,
            statusMensagemRecebida: false,
            statusMensagemLida: false,
            hashLogotipo: msg.hashLogotipo,
            nomeUsuario: msg.nomeUsuario,
            mensagem: msg.mensagem,
            origem: OrigemMensagem.DIREITA
        };
        brComDaoInstance.adicionaDataHora(m);
        mensagens.push(m);
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.MENSAGENS, JSON.stringify(mensagens), codEmpresa);
        brComDaoInstance.events.publish("msg.empresa." + msg.codEmpresa, {});
        brComDaoInstance.events.publish("pagina.empresa.atualizada", msg.codEmpresa);
        brComDaoInstance.marcaMensagemNaoLidaEmEmpresa(msg.codEmpresa);
    }

    enviaMensagemTextoParaEmpresa(codEmpresa: number, codUsuario: number, mensagem: string): number {
        let id = keyGen('brcom_mensagem');
        let mensagens = brComDaoInstance.obtemMensagensEmpresa(codEmpresa);
        var m = {
            id: id,
            tipo: TipoMensagem.SIMPLES,
            codEmpresa: codEmpresa,
            codUsuario: codUsuario,
            mensagem: mensagem,
            origem: OrigemMensagem.ESQUERDA,
            pendente: true
        };
        brComDaoInstance.adicionaDataHora(m);
        mensagens.push(m);
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.MENSAGENS, JSON.stringify(mensagens), codEmpresa);
        brComDaoInstance.events.publish("msg.empresa." + codEmpresa, {});
        return id;
    }

    atualizaSituacaoMensagemEnviada(codEmpresa: number, idMsgLocal: number, hexServidor: string) {
        let mensagens = brComDaoInstance.obtemMensagensEmpresa(codEmpresa);
        for (let msg of mensagens) {
            if (msg.pendente && msg.id && msg.id == idMsgLocal) {
                msg.pendente = false;
                msg.hexServidor = hexServidor;
                brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.MENSAGENS, JSON.stringify(mensagens), codEmpresa)
                return;
            }
        }
    }

    listaMensagemPendenteEnvio(codEmpresa: number): any[] {
        let mensagens = brComDaoInstance.obtemMensagensEmpresa(codEmpresa);
        var r = [];
        for (let msg of mensagens)
            if (msg.pendente && msg.id)
                r.push(msg);
        return r;
    }

    listaMensagemRecebidasPendentes(codEmpresa: number): any[] {
        let mensagens = brComDaoInstance.obtemMensagensEmpresa(codEmpresa);
        let r = []
        for(let msg of mensagens) {
            if (!msg.statusMensagemRecebida) {
                r.push(msg);
            }
        }
        return r
    }

    listaMensagemNaoLidasPendentes(codEmpresa: number): any[] {
        let mensagens = brComDaoInstance.obtemMensagensEmpresa(codEmpresa);
        let r = []
        for(let msg of mensagens) {
            if (!msg.statusMensagemLida && msg.origem == OrigemMensagem.DIREITA) {
                r.push(msg);
            }
        }
        return r
    }

    adicionaMensagemLink(msg: any) {
        let codEmpresa = msg.codEmpresa;
        let mensagens = brComDaoInstance.obtemMensagensEmpresa(codEmpresa);
        var m = {
            tipo: TipoMensagem.LINK,
            codEmpresa: msg.codEmpresa,
            codUsuario: msg.codUsuario,
            idMensagemUsuario: msg.idMensagemUsuario? msg.idMensagemUsuario : undefined,
            statusMensagemRecebida: false,
            statusMensagemLida: false,
            textoTipoMensagem: msg.textoTipoMensagem,
            mensagem: msg.mensagem,
            link: msg.link,
            labelLink: msg.labelLink,
            origem: OrigemMensagem.DIREITA
        };
        brComDaoInstance.adicionaDataHora(m);
        mensagens.push(m);
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.MENSAGENS, JSON.stringify(mensagens), codEmpresa)
        brComDaoInstance.events.publish("msg.empresa." + msg.codEmpresa, {});
        brComDaoInstance.events.publish("pagina.empresa.atualizada", msg.codEmpresa);
        brComDaoInstance.marcaMensagemNaoLidaEmEmpresa(msg.codEmpresa);
    }

    adicionaMensagemFacebook(msg: any) {
        let codEmpresa = msg.codEmpresa;
        let mensagens = brComDaoInstance.obtemMensagensEmpresa(codEmpresa);
        var m = {
            tipo: TipoMensagem.FACEBOOK,
            codEmpresa: msg.codEmpresa,
            codUsuario: msg.codUsuario,
            idMensagemUsuario: msg.idMensagemUsuario? msg.idMensagemUsuario : undefined,
            statusMensagemRecebida: false,
            statusMensagemLida: false,
            textoTipoMensagem: msg.textoTipoMensagem,
            mensagem: msg.mensagem,
            link: msg.link,
            labelLink: msg.labelLink,
            origem: OrigemMensagem.DIREITA
        };
        brComDaoInstance.adicionaDataHora(m);
        mensagens.push(m);
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.MENSAGENS, JSON.stringify(mensagens), codEmpresa);
        brComDaoInstance.events.publish("msg.empresa." + msg.codEmpresa, {});
        brComDaoInstance.events.publish("pagina.empresa.atualizada", msg.codEmpresa);
        brComDaoInstance.marcaMensagemNaoLidaEmEmpresa(msg.codEmpresa);
    }

    adicionaMensagemHtml(msg: any) {
        let codEmpresa = msg.codEmpresa;
        let mensagens = brComDaoInstance.obtemMensagensEmpresa(codEmpresa);
        var m = {
            tipo: TipoMensagem.HTML,
            codEmpresa: msg.codEmpresa,
            codUsuario: msg.codUsuario,
            idMensagemUsuario: msg.idMensagemUsuario? msg.idMensagemUsuario : undefined,
            statusMensagemRecebida: false,
            statusMensagemLida: false,
            textoTipoMensagem: msg.textoTipoMensagem,
            mensagemHtml: msg.mensagemHTML,
            mensagemResumo: msg.mensagemResumo,
            mensagemTexto: msg.mensagemTexto,
            link: ServidorProvider.URL_SERVIDOR_BRCOMUNIQUE +'/msg/' + msg.hashHTML + '.html',
            labelLink: msg.labelLink,
            origem: OrigemMensagem.DIREITA
        };
        brComDaoInstance.adicionaDataHora(m);
        mensagens.push(m);
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.MENSAGENS, JSON.stringify(mensagens), codEmpresa);
        brComDaoInstance.events.publish("msg.empresa." + msg.codEmpresa, {});
        brComDaoInstance.events.publish("pagina.empresa.atualizada", msg.codEmpresa);
        brComDaoInstance.marcaMensagemNaoLidaEmEmpresa(msg.codEmpresa);
    }

    obtemMensagensEmpresa(codEmpresa: number) {
        let mensagens = brComDaoInstance.getValorChaveLocalStorage(chaveLocalStorage.MENSAGENS, codEmpresa);
        if (mensagens)
            return JSON.parse(mensagens);
        else
            return [];
    }

    obtemDenunciasEmpresa(codEmpresa: number){
        let denuncias = brComDaoInstance.getValorChaveLocalStorage(chaveLocalStorage.DENUNCIAS, codEmpresa);
        if (denuncias){
            return JSON.parse(denuncias)
        }else {
            return [];
        }
    }
    
    atualizaEmpresa(codEmpresa: number, atalhos: any[], nomeEmpresa: string, hashLogotipo: string, site: string, 
        facebook: string, twitter: string, layoutRotinas: number) {
        this.loadInfoFromStorage();
        let grupo = brComDaoInstance.obtemGrupo(codEmpresa);
        grupo.Atalhos = atalhos;
        grupo.HashLogotipoEmpresa = hashLogotipo;
        grupo.NomeEmpresa = nomeEmpresa;
        grupo.Site = site;
        grupo.Facebook = facebook;
        grupo.Twitter = twitter;
        grupo.LayoutRotinas = layoutRotinas;
        brComDaoInstance.gravaGrupo(this.grupos);
    }

    atualizaStatusMensagemRecebida(codEmpresa: number, idMensagemUsuario: number):any {
        let mensagens = brComDaoInstance.obtemMensagensEmpresa(codEmpresa);
        for (let msg of mensagens) {
            if(msg.idMensagemUsuario && msg.idMensagemUsuario == idMensagemUsuario){
                msg.statusMensagemRecebida = true
                brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.MENSAGENS, JSON.stringify(mensagens), codEmpresa);
                return;
            }
        }
    }

    atualizaStatusMensagemLida(codEmpresa: number, idMensagemUsuario: number):any {
        let mensagens = brComDaoInstance.obtemMensagensEmpresa(codEmpresa);
        for (let msg of mensagens) {
            if(msg.idMensagemUsuario && msg.idMensagemUsuario == idMensagemUsuario){
                msg.statusMensagemLida = true
                brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.MENSAGENS, JSON.stringify(mensagens), codEmpresa);
                return;
            }
        }
    }

     adicionaMensagemNaoLida(msg: any)  {
        let listaId = [];
        let mensagensNaoLidas = brComDaoInstance.getValorChaveLocalStorage(chaveLocalStorage.LISTA_MENSAGENS_NAO_LIDAS, msg.codEmpresa);
        if (mensagensNaoLidas){
            listaId = JSON.parse(mensagensNaoLidas);
          }
        listaId.push(msg.idMensagemUsuario);
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.LISTA_MENSAGENS_NAO_LIDAS, JSON.stringify(listaId), msg.codEmpresa);
    }

    atualizaDenunciaEnviada(codEmpresa: number, idDenunciaLocal: number, idDenunciaServidor: number) {
        let denuncias = brComDaoInstance.obtemDenunciasEmpresa(codEmpresa);
        for (let denuncia of denuncias) {
            if (denuncia.idDenunciaLocal == idDenunciaLocal){
                denuncia.idDenunciaServidor = idDenunciaServidor
                denuncia.enviado = true
                brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.DENUNCIAS, JSON.stringify(denuncias), codEmpresa)
                return;
            }
        }
    }

    public getPlataformasSociaisEmpresa(codEmpresa: number): any {
        const redesSociais = brComDaoInstance.getValorChaveLocalStorage(chaveLocalStorage.REDES_SOCIAIS, codEmpresa);
        if (redesSociais) {
            return JSON.parse(redesSociais);
        }
        return redesSociais;
    }

    public setRedesSociaisEmpresa(codEmpresa: number, urlRedesSociais: any) {
        brComDaoInstance.setValorChaveLocalStorage(chaveLocalStorage.REDES_SOCIAIS, JSON.stringify(urlRedesSociais), codEmpresa);
    }

    private getValorChaveLocalStorage(chaveLocalStorage: chaveLocalStorage, codEmpresa?: number) {
        if (codEmpresa) {
            return localStorage[chaveLocalStorage + codEmpresa]
        } else {
            return localStorage[chaveLocalStorage]
        }
    }

    private setValorChaveLocalStorage(chaveLocalStorage: chaveLocalStorage, valorChaveLocalStorage: any, codEmpresa?: number) {
        if (codEmpresa) {
            localStorage[chaveLocalStorage + codEmpresa] = valorChaveLocalStorage;
        } else {
            localStorage[chaveLocalStorage] = valorChaveLocalStorage;
        }
    }
}


// WEBPACK FOOTER //
// ./src/service/BrComDao.ts